import React, { useState, useEffect } from 'react';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import classNames from 'classnames';
import format from 'date-fns/format';
import { makeStyles } from '@material-ui/core/styles';
import { notificationCenterWidth, RightSideBarWidth } from '../../../styleVariables';
import useMountEffect from '../../../mountEffect';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import * as logger from "../../../logger";
import AddRoundedIcon from '@material-ui/icons/AddRounded';

import { connect } from 'react-redux';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import {
  updateChatView, toggleChatSupport
} from "../../../store/actions/userActionCreators";
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import { freshChat } from '../../../configs/configs';
import FreshChat from 'react-freshchat';
import MobileStepper from '@material-ui/core/MobileStepper';
import { DialogTitle, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { biltyContinueClick } from '../../../store/actions/tripActionCreator';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { ExcelIcon, PdfIconWhite } from '../../../components/icons';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(theme => ({
  transactionDetailsDrawer: {
    width: 475,
    maxWidth: 475,
    [theme.breakpoints.down('sm')]: {
      top: '56px!important',
      height: 'calc(100vh - 0px)'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px!important',
      height: 'calc(100vh - 0px)'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  modal: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    },
    zIndex: theme.zIndex.drawer + 99
  },
  backdrop: {
    [theme.breakpoints.down('sm')]: {
      top: '0px'
    },
    [theme.breakpoints.up('sm')]: {
      top: '0px'
    }
  },
  container: {
    position: 'relative',
    overflowX: 'hidden',
    overflowY: 'auto',
    zIndex: 1,
    flexGrow: 1
  },
  sideBarDialogContentV1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 20,
    backgroundColor: '#f6f6f8'
  },
  sideBarDialogContentV2: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 20,
    backgroundColor: '#f6f6f8'
  },
  divTitle: {
    display: 'flex',
    alignItems: 'center',
    color: "#0b1323",
    fontSize: 18,
    marginBottom: 4,
    lineHeight: 1.33,
    letterSpacing: 'normal',
    textTransform: 'capitalize'
  },
  divSecTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    color: "rgba(11, 19, 35, 0.75)",
    marginBottom: 8
  },
  titleDiv: {
    display: 'flex',
    flexDirection: 'column'
  },
  downloadButton: {
    backgroundColor: '#09101e',
    padding: '6px 18px',
    borderRadius: '4px',
    color: 'white',
    textTransform: 'none !important',
    marginLeft: '16px !important',
    fontWeight: '500',
    boxShadow: 'none !important',
    '&:hover': {
      backgroundColor: '#09101e'
    }
  },
  dialogTitleV1: {
    paddingBottom: '12px !important'
  }
}));

const RightSideBar = ({
  rightSideBarOpen,
  toggleRightSideBar,
  user,
  data,
  transData,
  children,
  sideBarName,
  sideBarTitle,
  sideBarSecondaryTitle,
  handleSubmit,
  dispatchChatView,
  onEdit,
  onDelete,
  cStyle,
  payAgain,
  actionButtonClicked,
  showDownloadButtonBlack
}) => {
  const [validate, setValidate] = useState(false);
  const [updateChatView, setChatView] = useState(false);
  const [progress, setProgress] = useState(25);
  const [checkDataPopulated, setCheckDataPopulated] = useState(false);
  const [checkStatusAllTrue, setCheckStatusAllTrue] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    dispatchChatView(false);
  }, []);

  const handleClose = () => {
    if (toggleRightSideBar) {
      toggleRightSideBar()
    }
    dispatchChatView(true);
  }
  const handlePayAgain = () => {
    if (payAgain) {
      payAgain()
    }
    //dispatchChatView(true);
  }
  const handleSave = () => {
    if (handleSubmit) {
      handleSubmit()
    }
    //dispatchChatView(true);
  }

  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={rightSideBarOpen}
      ModalProps={{
        keepMounted: false,
        className: classes.modal,
        BackdropProps: {
          className: classes.backdrop
        },
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        //onBackdropClick: handleClose
      }}
      classes={{
        paper: classes.transactionDetailsDrawer
      }}
    >
      <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} siderBarType={'truckBook'}
        onClose={handleClose}
        onEdit={onEdit ? (e) => { onEdit(data, true) } : null}
        onDelete={onDelete ? (e) => { onDelete(data, true) } : null}
      >
        <div className={classes.titleDiv}>
          <div className={classes.divTitle}>
            {sideBarTitle ? sideBarTitle : '--'}
          </div>
          {/* {(!data || data && data.entityType != 'shopPayment') && <div className={classes.divSecTitle}>
            {sideBarSecondaryTitle ? sideBarSecondaryTitle : ''}
          </div>} */}
        </div>
        {sideBarSecondaryTitle && (!data || data && data.entityType != 'shopPayment') && <div className={classes.divSecTitle}>
          {sideBarSecondaryTitle ? sideBarSecondaryTitle : 'Title'}
        </div>}
      </SideBarDialogTitle >
      <SideBarDialogContent dividers className={cStyle ? classes.sideBarDialogContentV2 : classes.sideBarDialogContentV1}>
        {children}
      </SideBarDialogContent>
      <SideBarDialogActions className={classes.sideBarActions} >
        <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
          Close
        </Button>
        {showDownloadButtonBlack &&
          <Button variant="contained" className={classes.downloadButton} onClick={() => actionButtonClicked()}>
            Download
          </Button>
        }
         {/* {transData && transData.payoutStatus && transData.payoutStatus =='SUCCESS' &&
          <Button variant="contained" className={classes.downloadButton} onClick={() => handlePayAgain()}>
            Pay Again
          </Button>
        } */}
      </SideBarDialogActions>
    </Drawer >
  );
};

RightSideBar.propTypes = {
  rightSideBarOpen: PropTypes.bool,
  toggleRightSideBar: PropTypes.func
};
const RightSideBarWithRouter = withRouter(RightSideBar);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchChatView: (value) => dispatch(updateChatView(value)),
  dispatchToggleChatSupport: (value) => dispatch(toggleChatSupport(value)),
  dispatchBiltyContinueClick: (value) => dispatch(biltyContinueClick(value))
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RightSideBarWithRouter);
